import { render, staticRenderFns } from "./unauthorized.vue?vue&type=template&id=75689f96&scoped=true"
import script from "./unauthorized.ts?vue&type=script&lang=ts&external"
export * from "./unauthorized.ts?vue&type=script&lang=ts&external"
import style0 from "./unauthorized.less?vue&type=style&index=0&id=75689f96&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75689f96",
  null
  
)

export default component.exports